module["exports"] = [
  "#{common_cell_prefix}-###-####"
];
